module.exports = __webpack_public_path__ + "img/floship-logo-navy.e0279bc8.png";